import { useState, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PageHeader } from "@shared/components/PageHeader";
import { Button } from "@shared/ui/button";
import { ArrowLeft, ChevronLeft, ImageUp, Play, Plus } from "lucide-react";
import { Dashboard } from "../dashboard/dashboard";
import SlipLotsList from "../list/list";
import { CreateSlipLotDialog } from "../create/create";
import { useSlipLots } from "../../../hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { PAGE_SIZE } from "@shared/utils/constants";

const SlipLotsLanding = () => {
  const navigate = useNavigate();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  
  const remoteUtilityId = useRemoteUtilityId();
  const [searchParams] = useSearchParams();
  const currentPage = Number(searchParams.get("page") || 1);

  const filters = useMemo(
    () => ({
      remoteUtilityId: Number(remoteUtilityId),
      page: currentPage,
      limit: PAGE_SIZE,
      search: searchParams.get("search") || "",
      centre: searchParams.get("centre") || "",
      status: searchParams.get("status") || "",
      dateRange: searchParams.get("dateRange") || "",
    }),
    [remoteUtilityId, currentPage, searchParams],
  );

  const { data, isLoading } = useSlipLots(filters);
  const kpis = data?.kpis;

  return (
    <div className="flex h-full flex-col gap-4">
      {/* Header */}
      <div className="flex justify-between items-start mb-6">
        <div className="flex items-center gap-4">
          <ArrowLeft
            className="w-5 h-5 cursor-pointer text-gray-700"
            onClick={() => navigate("/cx/payments")}
          />
          <div className="flex flex-col">
            <PageHeader
              title={"Payment Slip Lots"}
              subtitle="Bulk-process cash payment slips from payment centres. Create lots, enter slip data manually or via barcode scan, auto-post clean slips to consumer ledgers, and quarantine anything that fails validation. Finance reconciles the lot total against the centre's cash deposit and signs off to close."
            />
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="default" onClick={() => setIsCreateModalOpen(true)}>
            <Plus className="h-4 w-4 mr-2" />
            New Slip Lot
          </Button>
        </div>
      </div>

      <Dashboard kpis={kpis} isLoading={isLoading} />
      <SlipLotsList
        tableData={data?.results || []}
        totalCount={data?.count || 0}
        isLoading={isLoading}
      />
      
      <CreateSlipLotDialog 
        isOpen={isCreateModalOpen} 
        onClose={() => setIsCreateModalOpen(false)} 
      />
    </div>
  );
};

export default SlipLotsLanding;
